import { render, staticRenderFns } from "./create_theme_copy.vue?vue&type=template&id=b6e9755a&scoped=true"
import script from "./create_theme_copy.vue?vue&type=script&lang=js"
export * from "./create_theme_copy.vue?vue&type=script&lang=js"
import style0 from "./create_theme_copy.vue?vue&type=style&index=0&id=b6e9755a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e9755a",
  null
  
)

export default component.exports